/**
 * Core
 */
import { useState } from "react";

/**
 * Styles
 */
import "./Indicator.scss";

const Indicator = ({
  iconIndicator,
  className,
  textLabel,
  isActive,
  onClick,
}) => {
  return (
    <div className="indicator__wrap">
      <div
        onClick={onClick}
        className={isActive ? `${className} active` : className}
      >
        <img src={iconIndicator} alt="icon" />
      </div>
      <span>{textLabel}</span>
    </div>
  );
};

export default Indicator;
